import React from "react";
import "./Loader.css";

export const Loader = () => {
	return <span class="loader"></span>;
};
